
import styles from './index.module.scss'
import { Button } from 'antd';
import { useContext, useMemo } from 'react';
import { AppContext } from '@utils/AppContext';
import Iconfont from '@utils/Iconfont';
import eventBus from '@utils/eventBus';
import { SELECT_ORG_TYPE } from '@utils/CONST'
import { useNavigate } from 'react-router-dom';

const list = [{
    title: 'AI试衣 ·平铺商品图秒上身 ',
    value: "tryonBatch",
}, {
    title: '换模特 ·海量模特随心换',
    value: "changeModelBatch",
}, {
    title: '换背景 ·室内户外背景任选',
    value: "changeBkgBatch",
}]


const DefaultEmpytPage = () => {
    const { globalUser, globalOrgInfo } = useContext(AppContext)
    const navigate = useNavigate()

    const ButtonText = useMemo(() => {
        return globalOrgInfo?.orgList?.length > 1 ? `切换团队账号` : '创建团队账号'
    }, [globalOrgInfo?.orgList])

    const teamClick = () => {
        if (globalOrgInfo?.orgList?.length > 1) {
            eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true })
        } else {
            eventBus.emit('OPEN_CREATE_TEAM')
        }
    }

    return (
        <div className={styles.DefaultEmpytPage}>
            {
                globalOrgInfo?.isPersonal ? <div className={styles.DefaultEmpytPageContent}>
                    <p>团队账号专属 · 批量生图模式 </p>
                    <div className={styles.nullImg}></div>
                    <Button className={styles.pageButton} type="primary" onClick={teamClick}>
                        <Iconfont className={styles.iconfont} type="icon-reuse" />{ButtonText}
                    </Button>
                </div> : (
                    <div className={styles.listWarp}>
                        {
                            list.map((item, index) => (
                                <div key={item.value} className={`${styles.listItem} ${styles[`listItem${index + 1}`]}`}
                                    onClick={() => { navigate(`/home/product/${item.value}/upload`) }}>
                                    <div className={styles.imgBox}></div>
                                    <div className={styles.title}>{item.title}</div>
                                    <Button className={styles.listWarpButton} type="primary">
                                        <Iconfont className={styles.iconfont} type="icon-general_dd" />新建任务
                                    </Button>
                                </div>
                            ))
                        }
                    </div>
                )
            }


        </div>
    )
}

export default DefaultEmpytPage